import { db } from '@/firebaseInit'
import _ from 'lodash'
import Vue from 'vue'

const entityPlural = 'clubSponsors'
const entitySingular = 'clubSponsor'

const debug = require('debug')(`OD::Lib:Data:${_.startCase(_.toLower(entityPlural))}`)

export default {
  bindAll(vm, { clubId }) {
    debug(vm.$vnode.tag, 'bindAll', { clubId })

    Vue.set(vm.loadings, entityPlural, true)
    vm.$bind(entityPlural, db.collection(`clubs/${clubId}/sponsors`))
      .then(items => {
        debug(vm.$vnode.tag, entityPlural, items)
        Vue.set(vm.loadings, entityPlural, false)
      })
      .catch(error => {
        debug(vm.$vnode.tag, entityPlural, 'error', error)
        Vue.set(vm.loadings, entityPlural, false)
        Vue.set(vm.dbErrors, entityPlural, error)
      })
  },
  bindItem(vm, { clubId, sponsorId }) {
    debug(vm.$vnode.tag, 'bindItem', { clubId, sponsorId })
    Vue.set(vm.loadings, entitySingular, true)
    vm.$bind(entitySingular, db.collection(`clubs/${clubId}/sponsors`).doc(sponsorId))
      .then(item => {
        debug(vm.$vnode.tag, entitySingular, item)
        Vue.set(vm.loadings, entitySingular, false)
      })
      .catch(error => {
        debug(vm.$vnode.tag, entitySingular, 'error', error)
        Vue.set(vm.loadings, entitySingular, false)
        Vue.set(vm.dbErrors, entitySingular, error)
      })
  },
  add(vm, user, item, { clubId }) {
    item.created = Date.now()
    item.createdBy = user ? user.uid : null
    debug(vm.$vnode.userSponsor, 'add', { user, item })
    vm.$firestoreRefs[entityPlural].add(item)
  },
  update(vm, user, newItem, item) {
    debug(vm.$vnode.tag, 'update', { user, newItem, item })
    const dbRef = vm.$firestoreRefs[entityPlural]
      ? vm.$firestoreRefs[entityPlural].doc(item.id)
      : vm.$firestoreRefs[entitySingular]
    dbRef.update(newItem)
  },
  delete(vm, user, item) {
    debug(vm.$vnode.tag, 'delete', { user, item })
    const dbRef = vm.$firestoreRefs[entityPlural]
      ? vm.$firestoreRefs[entityPlural].doc(item.id)
      : vm.$firestoreRefs[entitySingular]
    dbRef.delete()
  },
}
